import { Switch } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { useUser } from '../components/Auth/User';

/* Screens */
import {
  Ambulatorio,
  Ayuda,
  Internaciones,
  Medicamentos,
  Perfil,
  Protesis,
  TerminosCondiciones,
} from '../components/screens';

/* Components */
import SignIn from '../components/Auth/SignIn';
import SignOut from '../components/Auth/SignOut';
import Mantenimiento from '../layouts/Messages/Page/Mantenimiento';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import { OlvidePin } from '../components/Common/OlvidePin/components/OlvidePin';

const PrivateRoute = ({ children, ...props }) => {
  const { user } = useUser();

  return (
    <Route
      {...props}
      render={({ location }) => {
        return user ? (
          children
        ) : (
          <Redirect to={{ pathname: '/signin', state: { from: location } }} />
        );
      }}
    />
  );
};

const Pages = (props) => (
  <Box>
    <Switch>
      {/* Error/Services pages */}
      {/* Public routes */}
      <Route path='/signin'>
        <SignIn />
      </Route>
      <Route path='/mantenimiento'>
        <Mantenimiento />
      </Route>
      <Route path='/olvide-pin'>
        <OlvidePin />
      </Route>
      {/* Private routes */}
      <PrivateRoute exact path='/'>
        <Redirect to='/ambulatorio' />
      </PrivateRoute>
      <PrivateRoute exact path='/perfil'>
        <Perfil />
      </PrivateRoute>
      <PrivateRoute exact path='/terminos-condiciones'>
        <TerminosCondiciones />
      </PrivateRoute>
      <PrivateRoute path='/signout'>
        <SignOut />
      </PrivateRoute>
      <PrivateRoute path='/ayuda'>
        <Ayuda />
      </PrivateRoute>
      <PrivateRoute path='/ambulatorio'>
        <Ambulatorio />
      </PrivateRoute>
      <PrivateRoute path='/internaciones'>
        <Internaciones />
      </PrivateRoute>
      <PrivateRoute path='/protesis'>
        <Protesis />
      </PrivateRoute>
      <PrivateRoute path='/medicamentos'>
        <Medicamentos />
      </PrivateRoute>
    </Switch>
  </Box>
);

export default Pages;
